import type { DashboardConfig } from '../data/queries.js';

/** True se la superficie `key` è visibile per `role`. Default = visibile;
 *  si nasconde SOLO con un esplicito `false` (coerente con dashboard_config). */
export function isSurfaceVisible(cfg: DashboardConfig, role: string, key: string): boolean {
  return cfg[role]?.[key] !== false;
}

/** Risolve dal soggetto piu specifico al fallback di ruolo. Una persona puo
 * salvare sia true sia false; le vecchie configurazioni di ruolo continuano a
 * memorizzare soltanto gli OFF. */
export function isSurfaceVisibleForSubjects(
  cfg: DashboardConfig,
  subjects: readonly string[],
  key: string,
): boolean {
  for (const subject of subjects) {
    if (Object.prototype.hasOwnProperty.call(cfg[subject] ?? {}, key)) {
      return cfg[subject]?.[key] !== false;
    }
  }
  return true;
}

/** Ritorna un nuovo config con la visibilità di `key` impostata per `role`.
 *  Salva solo gli OFF: riaccendere rimuove la key. Non muta l'input. */
export function setSurfaceVisibility(
  cfg: DashboardConfig,
  role: string,
  key: string,
  visible: boolean,
): DashboardConfig {
  const roleCfg = { ...(cfg[role] ?? {}) };
  if (visible) delete roleCfg[key];
  else roleCfg[key] = false;
  return { ...cfg, [role]: roleCfg };
}

export function setPersonalSurfaceVisibility(
  cfg: DashboardConfig,
  subject: string,
  fallbackSubjects: readonly string[],
  key: string,
  visible: boolean,
): DashboardConfig {
  const subjectCfg = { ...(cfg[subject] ?? {}) };
  const inherited = isSurfaceVisibleForSubjects(cfg, fallbackSubjects, key);
  if (visible === inherited) delete subjectCfg[key];
  else subjectCfg[key] = visible;
  return { ...cfg, [subject]: subjectCfg };
}
